// ✅ RefinanceGoal.jsx — Mortgage Matrix (Step 2 – Select Refinance Goal)
import React from "react";
import styles from "./RefinanceForm.module.css";

function RefinanceGoal({ formData, setFormData, nextStep }) {
  const options = [
    "Decrease repayments",
    "Pay off loan faster",
    "Consolidate debts / Cash out",
  ];

  const handleSelectGoal = (goal) => {
    setFormData((prev) => ({
      ...prev,
      refinanceGoal: goal,
    }));
    nextStep();
  };

  return (
    <div className={styles.container}>
      <h3>What’s your refinancing goal?</h3>
      <p>Select the option that best matches what you’d like to achieve.</p>

      <div className={styles.optionList}>
        {options.map((option, index) => (
          <button
            key={index}
            type="button"
            className={`${styles.optionButton} ${
              formData.refinanceGoal === option ? styles.active : ""
            }`}
            onClick={() => handleSelectGoal(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default RefinanceGoal;
